import { useDispatch } from "react-redux";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { hideToast, showErrorToast, showSuccessToast } from "app/actions/toast_actions";
import type { IToast } from "app/components/React/Toast/types";
import { renderLoadingToast } from "app/pages/sales-intelligence/common-components/LoadingToast/LoadingToast";

export const useToasts = () => {
    const dispatch = useDispatch();

    const showSuccessToastLocal = (text: string) => {
        const content = (
            <Flex
                alignItems="center"
                gap="8px"
            >
                <SWReactIcons
                    iconName="checked-circle"
                    iconColor={colorsPalettes.green[300]}
                    size="sm"
                />
                {text}
            </Flex>
        );
        return dispatch(showSuccessToast(content));
    };

    const showErrorToastLocal = (text: string) => {
        const content = (
            <Flex
                alignItems="center"
                gap="8px"
            >
                <SWReactIcons
                    size="sm"
                    iconName="alert-circle"
                    iconColor={colorsPalettes.red["300"]}
                />
                {text}
            </Flex>
        );

        return dispatch(showErrorToast(content));
    };

    const showLoadingToast = (text: string) => {
        return dispatch(showSuccessToast(renderLoadingToast({ content: text, hideCloseIcon: true }), Date.now(), 0));
    };

    const hideToastLocal = (toast: IToast) => {
        dispatch(hideToast(toast));
    };

    return {
        showSuccessToast: showSuccessToastLocal,
        showErrorToast: showErrorToastLocal,
        showLoadingToast,
        hideToast: hideToastLocal,
    };
};
